<div class="sale-study-files-viewer-popup">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Study Files</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="closeModal()"
    ></button>
  </div>
  <div class="modal-body p-2">
    <app-edit-clinical-study
      [sale_id]="data.saleId"
      [horse_id]="data.horseId"
      [status_id]="data.statusId"
      (closedClicked)="closeModal()"
    ></app-edit-clinical-study>
  </div>
</div>
